function initFeaturedCollectionScroll(root = document) {
  const wraps = root.querySelectorAll('[data-fc-wrap]');

  wraps.forEach((wrap) => {
    const scroller = wrap.querySelector('[data-fc-scroll]');
    const prevBtn = wrap.querySelector('[data-fc-prev]');
    const nextBtn = wrap.querySelector('[data-fc-next]');
    if (!scroller || !prevBtn || !nextBtn) return;

    const isDesktop = () => window.matchMedia('(min-width: 769px)').matches;
    const step = () => Math.max(240, Math.round(scroller.clientWidth * 0.85));

    const update = () => {
      if (!isDesktop()) return;
      const max = scroller.scrollWidth - scroller.clientWidth;
      const x = scroller.scrollLeft;
      prevBtn.classList.toggle('is-disabled', x <= 1);
      nextBtn.classList.toggle('is-disabled', x >= max - 1);
    };

    prevBtn.addEventListener('click', () => isDesktop() && scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
    nextBtn.addEventListener('click', () => isDesktop() && scroller.scrollBy({ left:  step(), behavior: 'smooth' }));

    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // ✅ Drag-to-scroll (safe: doesn't break clicks)
    let down = false;
    let dragging = false;
    let startX = 0;
    let startLeft = 0;
    let pointerId = null;
    const DRAG_THRESHOLD = 8;

    scroller.style.cursor = 'grab';

    const isInteractive = (el) =>
      !!el.closest('a, button, input, select, textarea, summary, [role="button"], [data-no-drag]');

    scroller.addEventListener('pointerdown', (e) => {
      if (!isDesktop()) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;

      // 🔒 Don't hijack clicks on product links/buttons
      if (isInteractive(e.target)) return;

      down = true;
      dragging = false;
      startX = e.clientX;
      startLeft = scroller.scrollLeft;
      pointerId = e.pointerId;

      // Don't capture yet — only after user actually drags
      scroller.classList.add('is-dragging-potential');
    });

    scroller.addEventListener('pointermove', (e) => {
      if (!down) return;

      const dx = e.clientX - startX;

      if (!dragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;

        dragging = true;
        scroller.classList.add('is-dragging');
        scroller.style.cursor = 'grabbing';

        try { scroller.setPointerCapture(pointerId); } catch (_) {}
      }

      scroller.scrollLeft = startLeft - dx;
    });

    // If it was a drag, prevent the click that follows (capture phase)
    scroller.addEventListener(
      'click',
      (e) => {
        if (!dragging) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );

    const end = () => {
      if (!down) return;
      down = false;
      scroller.classList.remove('is-dragging', 'is-dragging-potential');
      scroller.style.cursor = 'grab';
      if (pointerId != null) {
        try { scroller.releasePointerCapture(pointerId); } catch (_) {}
      }
      pointerId = null;
      dragging = false;
    };

    scroller.addEventListener('pointerup', end);
    scroller.addEventListener('pointercancel', end);
    scroller.addEventListener('pointerleave', end);

    update();
    setTimeout(update, 500);
  });
}

document.addEventListener('DOMContentLoaded', () => initFeaturedCollectionScroll());
document.addEventListener('shopify:section:load', (e) => initFeaturedCollectionScroll(e.target));